import { Root } from "../stores/store-root";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

export interface Order {
  Id: string;
  Reference: string;

  SendingCurrencyCode: string;
  SendingCurrencyLabel: string;
  SendingCurrencySymbol: string;
  SendingCountryLabel: string;
  SendingCountryCode: string;

  ReceivingCurrencyCode: string;
  ReceivingCurrencyLabel: string;
  ReceivingCurrencySymbol: string;
  ReceivingCountryLabel: string;
  ReceivingCountryCode: string;

  ExchangeRate: string;
  ReceivingAmount?: number;
  SettlementAmount?: number;

  SendingAmount?: number;
  Fees?: number;

  CreatedByUserName: string;
  CreatedByUserSub: string;
  CreatedByName: string;
  CreatedAt?: Date;

  ExchangeType: string;
  DeliveryType: string;

  DeliveryBankAccount: string;
  DeliveryBank: string;
  DeliveryBankBranch: string;

  DeliveryOffice: string;
  DeliveryOfficeZoba: string;

  Status: string;

  PaidByUserName?: string;
  PaidBySub?: string;
  PaidByName?: string;
  PaidAt?: Date;

  CancelledByUserName?: string;
  CancelledBySub?: string;
  CancelledByName?: string;
  CancelledAt?: Date;

  ApprovedByUserName?: string;
  ApprovedBySub?: string;
  ApprovedByName?: string;
  ApprovedAt?: Date;

  RemitterName: string;
  RemitterEmail: string;
  RemitterPhone: string;

  BeneficiaryName: string;
  BeneficiaryEmail: string;
  BeneficiaryPhone: string;

  Notes: string;

  //new fields required by the client

  TypeOfID: string;
  IDNumber: string;
  IssueDate: string;
  IssuePlace: string;
  Address: string;

  AgencyRate?: number|undefined;
  ProfitInERN?: number|undefined;
  ProfiteInUSD?: number|undefined;
  EquavilantInUSD?: number|undefined;
  Commission?: number|undefined;
}

interface OrderFormBase extends Partial<Order> {}

export class OrderFormValues implements OrderFormBase {
  Id = "";
  Reference = "";

  SendingCurrencyCode = "";
  SendingCurrencyLabel = "";
  SendingCurrencySymbol = "";
  SendingAmount: number | undefined = undefined;
  SendingCountryLabel = "";
  SendingCountryCode = "";

  ReceivingCurrencyCode = "";
  ReceivingCurrencyLabel = "";
  ReceivingCurrencySymbol = "";
  ReceivingAmount: number | undefined = undefined;
  SettlementAmount: number | undefined = undefined;
  ReceivingCountryLabel = "Eritria";
  ReceivingCountryCode = "ER";

  CreatedByUserName = "";
  CreatedByUserSub = "";
  CreatedByName = "";
  CreatedAt?: Date = undefined;

  ExchangeType = "";
  DeliveryType = "";
  ExchangeRate = "";
  Fees = undefined;

  DeliveryBankAccount = "";
  DeliveryBank = "";
  DeliveryBankBranch = "";

  PaidByUserName = "";
  PaidBySub = "";
  PaidByName = "";
  PaidAt?: Date = undefined;

  CancelledByUserName? = "";
  CancelledBySub? = "";
  CancelledByName = "";
  CancelledAt?: Date = undefined;

  ApprovedByUserName? = "";
  ApprovedBySub? = "";
  ApprovedByName = "";
  ApprovedAt?: Date = undefined;

  DeliveryOffice = "Asmara";
  DeliveryOfficeZoba = "Maekel";

  Status = "0";

  RemitterName = "";
  RemitterEmail = "";
  RemitterPhone = "";

  BeneficiaryName = "";
  BeneficiaryEmail = "";
  BeneficiaryPhone = "";

  Notes = "";

  //Fields required
  TypeOfID = "";
  IDNumber = "";
  IssueDate = "";
  IssuePlace = "";
  Address = "";

  AgencyRate: number | undefined= 0;
  ProfitInERN: number | undefined = 0;
  ProfiteInUSD? : number | undefined= 0;
  EquavilantInUSD: number | undefined = 0;
  Commission?: number|undefined=0;

  constructor(init?: Partial<Order>) {
    Object.assign(this, init);
  }
}

export enum OrderStatus {
  PendingReview,
  ReadyForCollection,
  Paid,
  Rejected,
  Cancelled,
  InProgress,
  NotSubmitted,
}

export const createTransferOrder = (
  order: OrderFormValues,
  store: Root
): OrderFormValues => {
  let values: OrderFormValues;
  values = _.clone(order);
  values.Reference = `SA${store.generateRandom().toString()}`;
  values.CreatedAt = new Date();
  values.CreatedByName = `${store.Users.Name} ${store.Users.FamilyName}`;
  values.CreatedByUserName = store.Users.UserName;
  values.CreatedByUserSub = store.Users.Sub;
  values.Id = uuidv4();
  values.SendingCountryCode = store.Users.Country;
  values.SendingCountryLabel = store.Users.Country;
  values.AgencyRate = store.Exchanges.USD_To_ERN?.AgencyRate;

  return values;
};

export const isNewTransferOrder = (Order: OrderFormValues): boolean => {
  return !Order.SendingAmount;
};

export const cancelTransferOrder = (
  Order: OrderFormValues,
  store: Root
): OrderFormValues => {
  let values: OrderFormValues;
  values = _.clone(Order);
  values.CancelledAt = new Date();
  values.CancelledByName = `${store.Users.Name} ${store.Users.UserName}`;
  values.CancelledBySub = store.Users.Sub;
  values.CancelledByUserName = store.Users.UserName;

  return values;
};

export const rejectTransferOrder = (
  Order: OrderFormValues,
  store: Root
): OrderFormValues => {
  return cancelTransferOrder(Order, store);
};

export const payTransferOrder = (
  Order: OrderFormValues,
  store: Root
): OrderFormValues => {
  let values: OrderFormValues;
  values = _.clone(Order);
  values.PaidBySub = store.Users.Sub;
  values.PaidByName = `${store.Users.Name} ${store.Users.FamilyName}`;
  values.PaidByUserName = store.Users.UserName;
  values.PaidAt = new Date();
  return values;
};

export const approveTrasnferorder = (
  order: OrderFormValues,
  store: Root
): OrderFormValues => {
  let values: OrderFormValues;
  values = _.clone(order);
  values.ApprovedBySub = store.Users.Sub;
  values.ApprovedByName = `${store.Users.Name} ${store.Users.FamilyName}`;
  values.ApprovedByUserName = store.Users.UserName;
  values.ApprovedAt = new Date();
  return values;
};
